import { LinearProgress, Stack, Typography, Box } from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";

interface Props {
  message: string;
  type?: "loading" | "error";
}

const StatusRow = ({ message, type = "loading" }: Props) => (
  <Box
    sx={{
      flex: 1,
    }}
  >
    {type === "loading" ? (
      <Stack sx={{ padding: 2, gap: 2, justifyItems: "center" }}>
        <LinearProgress color="primary" />
        <Typography variant="subtitle2">{message}</Typography>
      </Stack>
    ) : (
      <Stack direction="row" sx={{ padding: 2, alignItems: "center", gap: 1 }}>
        <ErrorIcon color="error" />
        <Typography variant="subtitle2">{message}</Typography>
      </Stack>
    )}
  </Box>
);

export default StatusRow;
